var map = {
	"./Loading-Icon.gif": 1022,
	"./app-awareness-phone.png": 451,
	"./app-modal-android@2x.png": 452,
	"./app-modal-iphone@2x.png": 453,
	"./app-promo-banner-background.png": 1023,
	"./box-prices/2-portions.png": 1024,
	"./box-prices/2-portions.webp": 1025,
	"./box-prices/4-portions.png": 1026,
	"./box-prices/4-portions.webp": 1027,
	"./box-prices/best-value.png": 454,
	"./box-prices/box-prices-hero.jpg": 572,
	"./box-prices/couples-box.jpg": 1028,
	"./box-prices/family-box.jpg": 1029,
	"./box-prices/four-person-box.jpg": 449,
	"./box-prices/most-popular.png": 455,
	"./box-prices/two-person-box.jpg": 448,
	"./discount-modal-header.jpg": 456,
	"./earn-reward-background.jpg": 1030,
	"./five-recipes/five-recipes.png": 1031,
	"./gousto-boxes.jpg": 1032,
	"./gousto-welcome-journey-rollover.jpg": 1033,
	"./hungry-for-savings.png": 1034,
	"./menu/FebYouary_desktop.jpg": 1035,
	"./menu/FebYouary_mobile.jpg": 1036,
	"./menu/FebYouary_tablet.jpg": 1037,
	"./menu/default_desktop_no_click.png": 1038,
	"./menu/default_mobile_no_click.png": 1039,
	"./menu/default_tablet_no_click.png": 1040,
	"./menu/spottyTileBorder.png": 457,
	"./my-gousto-pricing-modal.svg": 1041,
	"./pause-osr-modal-bg.jpg": 1042,
	"./product-placeholder.png": 299,
	"./recipe-placeholder.png": 154,
	"./red-rice-pattern.png": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;